<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :model="searchForm" :inline="true" size="mini" label-width="100px" ref="searchForm">
        <el-form-item label="产品型号" prop="bigModel">
          <el-input v-model.trim="searchForm.bigModel" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="品类" prop="category">
          <el-input v-model.trim="searchForm.category" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="产品类别" prop="categoryType">
          <el-select v-model="searchForm.categoryType" filterable placeholder="整体">
            <el-option label="整体" value=""></el-option>
            <el-option v-for="item in unsaleOrderTypeList" :label="item.val" :key="item.val" :value="item.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额/销量">
          <el-checkbox-group v-model="searchForm.showTypeList" @change="selectList(1)">
            <el-checkbox
              label="saleamount"
              v-if="columnJurisdiction"
              :disabled="searchForm.showTypeList.length == 1 && searchForm.showTypeList[0] == 'saleamount'"
            >
              金额
            </el-checkbox>
            <el-checkbox
              label="salenum"
              :disabled="!columnJurisdiction || (searchForm.showTypeList.length == 1 && searchForm.showTypeList[0] == 'salenum')"
            >
              销量
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="本月销售等级" prop="saleLocation">
          <el-select v-model="searchForm.saleLocation" filterable @change="onSearch">
            <el-option v-for="item in positioning" :label="item.val" :key="item.val" :value="item.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款时间">
          <form-month-range
            :form="searchForm"
            startKey="payDateStart"
            endKey="payDateEnd"
            :usingTime="false"
            valueFormat="yyyy-MM"
            dateType="month"
          ></form-month-range>
        </el-form-item>
        <el-form-item label="上市时间">
          <form-date-range :form="searchForm" startKey="upDateStart" endKey="upDateEnd" :usingTime="false" valueFormat="yyyy/MM/dd"></form-date-range>
        </el-form-item>
        <el-form-item label="店铺">
          <el-select v-model="searchForm.storeCode" @change="storeOptionsChange" filterable collapse-tags multiple reserve-keyword ref="select">
            <el-option v-if="!all" label="全部" value=""></el-option>
            <el-option v-if="all" label="取消所有" value="cancleAll"></el-option>
            <el-option v-for="item in storeCodeData" :label="item.content" :key="item.id" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button type="primary" size="mini" @click="selectList">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="resetSearchForm">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button
          type="primary"
          size="mini"
          @click="onExport"
          v-loading.fullscreen.lock="loadingExport"
          element-loading-text="数据导出中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          导出
        </el-button>
      </template>
      <el-table
        border
        stripe
        ref="table"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :data="tableData.content"
        :height="maxTableHeight"
        @sort-change="handleSortChange"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          :fixed="item.fixed"
          :min-width="item.width"
          :sortable="item.sortable ? 'custom' : false"
          show-overflow-tooltip
          v-for="item in columnData"
          :key="item.prop"
          :align="item.label == '图片' ? 'left' : 'right'"
        >
          <template slot="header">
            <template v-if="item.label.includes('销量')">
              <span>{{ item.label }}</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <span class="el-icon-question"></span>
                <div slot="content">包含京东入仓销量</div>
              </el-tooltip>
            </template>
            <span v-else>{{ item.label }}</span>
          </template>
          <template slot-scope="scope">
            <template v-if="item.label === '图片'">
              <template v-if="scope.row.photoUrls && scope.row.photoUrls.length">
                <el-link :underline="false" type="primary" @click="viewImg(scope.row)">查看</el-link>
              </template>
            </template>
            <template v-else-if="item.label === '产品型号'">
              <el-link :underline="false" type="primary" @click="model(scope.row)">{{ scope.row[item.prop] }}</el-link>
            </template>
            <template v-else-if="item.label === '月均销量' || item.label === '月均销售额'">
              {{ Number(scope.row[item.prop]).toLocaleString() }}
            </template>
            <template v-else-if="item.label.includes('年') && searchForm.storeCode.length != 1">
              {{ Number(scope.row[item.prop]).toLocaleString() }}
            </template>
            <template v-else-if="item.label === '上月销售等级'">
              {{ scope.row[item.prop] }}
            </template>
            <template v-else-if="item.label.includes('同比') || item.label.includes('合计')">
              <span :style="{ color: getColorByValue(scope.row[item.prop]) }">
                {{ scope.row[item.prop] }}
              </span>
            </template>
            <template v-else>
              {{ scope.row[item.prop] }}
            </template>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <div>
            <el-pagination
              @size-change="operationSizeChange"
              @current-change="operationCurrentChange"
              :current-page="tableData.pageNum"
              :page-sizes="[30, 100, 500, 1000]"
              :page-size="tableData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
            ></el-pagination>
          </div>
        </div>
      </template>
    </table-panel>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close>
      <imgShow :imgList="imgList"></imgShow>
    </el-dialog>
  </div>
</template>

<script>
import customProps from './customProps.mixin';
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';
import moment from 'moment';
import imgShow from '@/views/components/imgShow';

export default {
  mixins: [customProps, pagePathMixin, tableMixin],
  components: {
    imgShow,
  },
  name: 'ModelSalesTable',
  data() {
    return {
      loadingExport: false,
      loading: false,
      imgFormVisible: false,
      tableData: {
        content: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      imgList: [],
      searchForm: {
        showTypeList: [],
        payDateStart: moment().subtract(6, 'months').format('YYYY-MM'),
        payDateEnd: moment().subtract(1, 'months').format('YYYY-MM'),
      },
      exportForm: {},
      unsaleOrderTypeList: [],
      positioning: [],
      orderStatusList: [],
      storeCodeData: [],
      all: false,
      reportName: 'largeSizeDetails',
      timeText: {},
    };
  },
  mounted() {
    this.refreshTime();
    this.unsaleOrderType();
    this.queryMarketingPositioning();
    this.getOptions();
    setTimeout(() => {
      this.$set(this.searchForm, 'showTypeList', this.columnJurisdiction ? ['saleamount', 'salenum'] : ['salenum']);
      this.onSearch();
    }, 200);
  },
  methods: {
    // 根据值的正负返回颜色
    getColorByValue(value) {
      const numValue = parseFloat(value);
      if (isNaN(numValue)) {
        return '';
      }
      return numValue >= 0 ? '#0BB78E' : 'red';
    },
    model(row) {
      this.openSubPage({
        name: 'ProductDetails',
        params: {
          bigModel: row.bigModel,
          category: row.categoryName,
        },
      });
    },
    onSkuCodeFocus(index) {
      this.inputIndex = index;
      if (index == 1) {
        this.inputData = this.orderStatusList.category;
      } else if (index == 2) {
        this.inputData = this.orderStatusList.bigModel;
      }
    },
    querySkuList(queryString, cb) {
      let data = this.inputData;
      if (!data) {
        cb([]);
        return;
      }
      let results = queryString
        ? data.map(v => v.content).filter(item => item.toLowerCase().includes(queryString.toLowerCase()))
        : data
        ? data.map(v => v.content)
        : [];
      if (!results || !results.length) {
        cb([]);
        return;
      }
      results = results.map(item => ({
        ...item,
        value: item,
      }));
      cb(results);
    },
    getOptions(type) {
      setTimeout(
        () => {
          let data = {
            bigModel: this.searchForm.bigModel,
            category: this.searchForm.category,
          };
          this.$q.newProduct.dynamicOptions({ data: data }).then(data => {
            if (data.code === '200') {
              this.orderStatusList = data.data;
            } else {
              this.$message.error(data.message);
            }
          });
        },
        type ? 200 : 0
      );
    },
    resetSearchForm() {
      this.searchForm = {
        payDateStart: moment(new Date()).subtract(6, 'months').format('YYYY-MM'),
        payDateEnd: moment(new Date()).subtract(1, 'months').format('YYYY-MM'),
        storeCode: [],
        showTypeList: this.columnJurisdiction ? ['saleamount', 'salenum'] : ['salenum'],
      };
      this.$refs.table.clearSort();
      this.tableData.pageNum = 1;
      this.getOptions();
      this.onSearch();
    },
    selectList(type) {
      if (type == 1) {
        this.searchForm.sortField = '';
        this.searchForm.sortOptions = '';
      }
      this.$refs.table.clearSort();
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onSearch(type) {
      this.loading = true;
      const param = {
        num: this.tableData.pageNum,
        size: this.tableData.pageSize,
        ...this.searchForm,
      };
      this.exportForm = param;
      this.bigModelStoreOptions();
      this.queryMarketingPositioning();
      this.$q.newProduct
        .modelSaleDetail({ data: JSON.stringify(param) })
        .then(res => {
          if (res.code == 200) {
            if (!type) {
              this.pagingColumnData = res.data.keyVoList;
              this.customColumn();
            }
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    operationSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      this.tableData.pageNum = 1;
      this.onSearch(true);
    },
    operationCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.onSearch(true);
    },
    async refreshTime() {
      let res = await this.$q.common.refreshTime({ fragment: [54] });
      this.timeText = res.data;
    },
    unsaleOrderType() {
      this.$q.productModelDetails.queryMarketingCategory({}).then(data => {
        if (data.code === '200') {
          this.unsaleOrderTypeList = data.data;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    storeOptionsChange(val) {
      this.$refs.select.query = '';
      if (val.includes('')) {
        this.searchForm.storeCode = this.storeCodeData.map(v => v.id);
        this.all = true;
      } else if (val.includes('cancleAll')) {
        this.searchForm.storeCode = [];
        this.all = false;
      }
    },
    bigModelStoreOptions() {
      let data = {
        ...this.exportForm,
        type: 1,
      };
      this.$q.productModelDetails.bigModelStoreOptions({ data: data }).then(data => {
        if (data.code === '200') {
          this.storeCodeData = data.data;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    queryMarketingPositioning() {
      const params = {
        params: {
          payDateEnd: this.searchForm.payDateEnd,
          payDateStart: this.searchForm.payDateStart,
        },
      };
      this.$q.productModelDetails.bigModelMarketingPositioning(params).then(data => {
        if (data.code === '200') {
          this.positioning = data.data;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    // 查看图片
    viewImg(row) {
      this.imgFormVisible = true;
      this.imgList = [];
      this.imgList = row.photoUrls.map(v=>v.photoUrl);
    },
    handleSortChange({ column, prop, order }) {
      this.tableData.pageNum = 1;
      this.searchForm.sortField = prop;
      this.searchForm.sortOptions = order === 'ascending' ? '0' : order === 'descending' ? '1' : '';
      this.onSearch(true);
    },
    // 导出 --新接口
    onExport() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: 'Loading',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)',
      // });
      // let params = {
      //   taskDTO: {
      //     appCode: 'ec-pc-api',
      //     paramMap: this.exportForm,
      //     reportName: 'modelSaleExport',
      //   },
      //   columnDTOs: [],
      // };
      // let labels = this.columnData.map(v => v.label);
      // let props = this.columnData.map(v => v.prop);
      // props.forEach((prop, index) => {
      //   params.columnDTOs.push({
      //     columnName: labels[index],
      //     parentColumnName: null,
      //     fieldName: prop,
      //     fieldType: 'string',
      //     columnFormat: null,
      //   });
      // });
      // // 不导出图片列
      // params.columnDTOs = params.columnDTOs.filter(v => v.columnName !== '图片');
      // this.$q.common.customExportExcel({ data: params }).then(res => {
      //   if (res.success) {
      //     this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
      //     loading.close();
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$q.newProduct.modelSaleDetailExport({data: this.exportForm,options: {responseType: 'blob'}}).then(res => {
        let fileName = '型号销量表'+ moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        this.blobDownload(res, `${fileName}.xlsx`);
        loading.close()
        this.isShowDownload = false
      })
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab {
  >>> .search-outer>div {
    padding: 0;
  }
}

.footerBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input, >>> .el-autocomplete, >>> .el-checkbox-group {
    width: 240px !important;
  }
}

>>> .date-range .single-date {
  width: 110px !important;
}
</style>
